import React, { useEffect, useState } from 'react';

interface InArticleAdProps {
  className?: string;
}

export const InArticleAd: React.FC<InArticleAdProps> = ({ className = '' }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Defer AdSense loading for better performance
    const loadAdSense = () => {
      if (!window.adsbygoogle) {
        const script = document.createElement('script');
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9957943271015513';
        script.crossOrigin = 'anonymous';
        script.async = true;
        script.onload = () => setIsLoaded(true);
        document.head.appendChild(script);
      } else {
        setIsLoaded(true);
      }

      if (window.adsbygoogle && isLoaded) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadAdSense);
    } else {
      setTimeout(loadAdSense, 150);
    }
  }, [isLoaded]);

  return (
    <div className={`my-8 ${className}`}>
      <ins 
        className="adsbygoogle"
        style={{ display: 'block', textAlign: 'center' }}
        data-ad-layout="in-article"
        data-ad-format="fluid"
        data-ad-client="ca-pub-9957943271015513"
        data-ad-slot="6357352686"
      />
    </div>
  );
}; 